import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RouterName } from "../../router";
import OnboardingPage from "modules/Main/pages/OnboardingPage";

const GuestRouter = (props: any) => {
  const navigate = useNavigate();
  const isOnBoarded = localStorage.getItem("recipe_onBoarded");

  useEffect(() => {
    if (isOnBoarded !== "true") {
      navigate(RouterName.ONBOARDING);
    }
  }, []);

  return isOnBoarded === "true" ? <>{props.children}</> : <><OnboardingPage /></>;
};

export default GuestRouter;
